<template><div><h1>VUX V2.7.0 released</h1>
<h2><a href="/en/components/calendar.html">Calendar</a></h2>
<ul><li>[fix] fix top border #2104</li>
</ul>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[fix] fix ssr rendering issue</li>
</ul>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[fix] fix default selected item missing issue #2122</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] fix ssr i18n bug</li>
<li>[fix] fix datetime still shows when prop:readonly is true #2079</li>
</ul>
<h2><a href="/en/components/flow.html">Flow</a></h2>
<ul><li>[feature] add slot:title for flow-state #2010</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] call render function on created hook instead of mounted(ssr)</li>
<li>[feature] add prop:disable-weekend #2105</li>
<li>[feature] add prop:disable-date-function #2105</li>
<li>[fix] remove useless re-render function #2066</li>
</ul>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[change] picker move distance do not respect html[data-dpr] by default #2082 #1979</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] add prop:popup-title(use component:popup-header) #1866</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] fix vue@2.5.0 scope issue #2076</li>
</ul>
<h2><a href="/en/components/qrcode.html">Qrcode</a></h2>
<ul><li>[fix] fix errors when value is undefined #2070</li>
<li>[change] use style to set width and height #2075</li>
</ul>
<h2><a href="/en/components/selector.html">Selector</a></h2>
<ul><li>[fix] fix ssr rendering issue</li>
<li>[fix] fix placeholder not show when value is null #2101</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[enhance] set shorter distance for first and last item for better experience</li>
<li>[feature] add event:on-get-height #2112</li>
<li>[enhance] stop interval if auto is set to false #2027</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[fix] fix vue@2.5.0 scope issue #2076</li>
<li>[feature] add prop:popup-title(use component:popup-header) #1866</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] add event:on-click-mask #2102</li>
</ul>
<h2><a href="/en/components/x-switch.html">XSwitch</a></h2>
<ul><li>[feature] support prop:value-map #2104</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.0 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.0-129.vue?21fceaab